import { Button } from '@chakra-ui/button'
import { useDisclosure } from '@chakra-ui/hooks'
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
} from '@chakra-ui/modal'
import { useRef, useState } from 'react'
import { verificacaoDeProdutos } from '../functions'
import { Text } from '@chakra-ui/layout'

export function VerificacaoProdutos() {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const cancelRef = useRef()

  const [loading, setLoading] = useState(false)

  async function handleVerification() {
    setLoading(true)
    const response = await verificacaoDeProdutos()

    console.log(response)
    setLoading(false)
  }

  return (
    <>
      <Button variant="outline" maxW="300px" w="100%" onClick={onOpen}>
        Verificação de produtos
      </Button>
      <AlertDialog
        motionPreset="slideInBottom"
        leastDestructiveRef={cancelRef}
        onClose={onClose}
        isOpen={isOpen}
        isCentered
      >
        <AlertDialogOverlay />

        <AlertDialogContent>
          <AlertDialogHeader>
            <Text fontSize="md" fontWeight="semibold">
              Você tem certeza que deseja fazer a verificação de produtos?
            </Text>
          </AlertDialogHeader>
          <AlertDialogCloseButton />
          <AlertDialogBody fontSize="md">
            Essa ação pode demorar alguns minutos.
          </AlertDialogBody>
          <AlertDialogFooter>
            <Button ref={cancelRef} onClick={onClose}>
              Não
            </Button>
            <Button
              colorScheme="blue"
              ml={3}
              onClick={() => handleVerification()}
              isLoading={loading}
            >
              Sim
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  )
}
